import React from 'react';
import { BatteryWarning, Activity } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-138">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="max-w-3xl mx-auto" data-id="element-140">
          <div className="text-center mb-12" data-id="element-141">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-142">
              ¿Se ha despertado hoy sintiéndose{' '}
              <span className="text-red-600" data-id="element-143">más cansado</span> que cuando se
              acostó?
            </h2>
          </div>

          <div className="bg-red-50 rounded-2xl p-8 md:p-10 border border-red-100 shadow-sm mb-10" data-id="element-144">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-145">
              <div className="bg-red-100 p-4 rounded-full shrink-0" data-id="element-146">
                <BatteryWarning className="w-8 h-8 text-red-600" data-id="element-147" />
              </div>
              <div data-id="element-148">
                <p className="text-xl text-gray-800 leading-relaxed font-medium" data-id="element-149">
                  ¿Siente que, después de los 55, su cuerpo simplemente decidió
                  "apagarse" y cada comida le produce un sueño incontrolable y
                  pesadez?
                </p>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-gray-700" data-id="element-150">
            <p className="text-xl leading-relaxed" data-id="element-151">
              <strong className="text-gray-900" data-id="element-152">Usted no está "viejo".</strong>{' '}
              Su metabolismo no ha muerto, simplemente está atrapado en un ciclo
              de inflamación y picos de azúcar causados por el estilo de vida
              procesado de los Estados Unidos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}